export function init() {
    const tooltipContainers = document.querySelectorAll('.tooltip-container');
    [...tooltipContainers].forEach(container => {
        container.addEventListener('mouseover', () => showTooltip(container));
        container.addEventListener('mouseout', () => hideTooltip(container));
    });
}

function showTooltip(element) {
    const tooltip = element.querySelector('.tooltip');

    if (!tooltip) {
        return;
    }

    tooltip.classList.remove('tooltip-top', 'tooltip-bottom', 'tooltip-left', 'tooltip-right');

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const tooltipDistanceFromEdge = 50;

    const distanceToLeft = rect.left;
    const distanceToRight = viewportWidth - rect.right;

    const tooltipWidth = tooltip.offsetWidth + 20;

    if (tooltipWidth > distanceToLeft && tooltipWidth > distanceToRight) {
        tooltip.classList.add('tooltip-top');
    } else if (distanceToRight < tooltipDistanceFromEdge && distanceToLeft > tooltipDistanceFromEdge) {
        tooltip.classList.add('tooltip-left');
    } else if (distanceToLeft < tooltipDistanceFromEdge && distanceToRight > tooltipDistanceFromEdge) {
        tooltip.classList.add('tooltip-right');
    } else {
        tooltip.classList.add('tooltip-top');
    }
    element.classList.add('show-tooltip');
}

function hideTooltip(element) {
    element.classList.remove('show-tooltip');
}
